import './firstheader.css';


const FirstHeader = () => {
    return (
        <div classNmae='head-container'>
            <header className='firstheader'>
                <a href='/'><img src='./img/logo.PNG' alt="logo" className="logo" /></a>
            </header>
        </div>
    );
}

export default FirstHeader;